import _ from 'lodash';
import { TABLE_MODEL } from '../../groupMetricsTable.model';
import { getCellName } from '../../GroupMetricsTable.service';
import { CONSTANT_CELLS } from '../../GroupMetricsTable.consts';

export const getCols = ({
  selectedGroupIsSynced,
  availableMetricsWidgetsByName
}) => [
  {
    dataPoint: TABLE_MODEL.TEAM_NAME,
    name: 'TEAM NAME',
    tableCellHeadProps: {
      style: {
        paddingLeft: '3.2rem'
      }
    }
  },
  {
    dataPoint: TABLE_MODEL.MEMBERS,
    name: selectedGroupIsSynced ? 'MEMBERS' : 'DIRECT MEMBERS',
    tableCellProps: {
      style: { width: '10%' }
    }
  },
  {
    dataPoint: TABLE_MODEL.CYCLE_TIME,
    subscribeOnHover: true,
    name: getCellName(TABLE_MODEL.CYCLE_TIME, availableMetricsWidgetsByName),
    tableCellProps: {
      style: { width: '15%' }
    }
  },
  {
    dataPoint: TABLE_MODEL.PR_SIZE,
    subscribeOnHover: true,
    name: getCellName(TABLE_MODEL.PR_SIZE, availableMetricsWidgetsByName),
    tableCellProps: {
      style: { width: '10%' }
    }
  },
  {
    // MERGE FREQUENCY:
    dataPoint: TABLE_MODEL.PR_MERGED,
    subscribeOnHover: true,
    name: getCellName(TABLE_MODEL.PR_MERGED, availableMetricsWidgetsByName),
    tableCellProps: {
      style: { width: '10%' }
    }
  },
  {
    // DEPLOY FREQUENCY:
    dataPoint: TABLE_MODEL.RELEASES_COUNT,
    subscribeOnHover: true,
    name: getCellName(
      TABLE_MODEL.RELEASES_COUNT,
      availableMetricsWidgetsByName
    ),
    tableCellProps: {
      style: { width: '11%' }
    }
  },
  {
    dataPoint: TABLE_MODEL.TIME_TO_PR,
    subscribeOnHover: true,
    name: getCellName(TABLE_MODEL.TIME_TO_PR, availableMetricsWidgetsByName),
    tableCellProps: {
      style: { width: '10%' }
    }
  },
  {
    dataPoint: TABLE_MODEL.TIME_TO_REVIEW,
    subscribeOnHover: true,
    name: getCellName(
      TABLE_MODEL.TIME_TO_REVIEW,
      availableMetricsWidgetsByName
    ),
    tableCellProps: {
      style: { width: '10%' }
    }
  },
  {
    dataPoint: TABLE_MODEL.REVIEW_TIME,
    subscribeOnHover: true,
    name: getCellName(TABLE_MODEL.REVIEW_TIME, availableMetricsWidgetsByName),
    tableCellProps: {
      style: { width: '10%' }
    }
  },
  {
    dataPoint: TABLE_MODEL.TIME_TO_PROD,
    subscribeOnHover: true,
    name: getCellName(TABLE_MODEL.TIME_TO_PROD, availableMetricsWidgetsByName),
    tableCellProps: {
      style: { width: '10%' }
    }
  },
  {
    dataPoint: TABLE_MODEL.REVIEW_DEPTH,
    subscribeOnHover: true,
    name: getCellName(TABLE_MODEL.REVIEW_DEPTH, availableMetricsWidgetsByName),
    tableCellProps: {
      style: { width: '10%' }
    }
  },
  {
    dataPoint: TABLE_MODEL.NEW_WORK,
    subscribeOnHover: true,
    name: getCellName(TABLE_MODEL.NEW_WORK, availableMetricsWidgetsByName),
    tableCellProps: {
      style: { width: '10%' }
    }
  },
  {
    dataPoint: TABLE_MODEL.REFACTOR,
    subscribeOnHover: true,
    name: getCellName(TABLE_MODEL.REFACTOR, availableMetricsWidgetsByName),
    tableCellProps: {
      style: { width: '10%' }
    }
  },
  {
    dataPoint: TABLE_MODEL.REWORK,
    subscribeOnHover: true,
    name: getCellName(TABLE_MODEL.REWORK, availableMetricsWidgetsByName),
    tableCellProps: {
      style: { width: '10%' }
    }
  },
  {
    dataPoint: TABLE_MODEL.PR_MERGED_WITHOUT_REVIEW,
    subscribeOnHover: true,
    name: getCellName(
      TABLE_MODEL.PR_MERGED_WITHOUT_REVIEW,
      availableMetricsWidgetsByName
    ),
    tableCellProps: {
      style: { width: '10%' }
    }
  },
  {
    dataPoint: TABLE_MODEL.COMMIT_CODE_CHANGES,
    subscribeOnHover: true,
    name: getCellName(
      TABLE_MODEL.COMMIT_CODE_CHANGES,
      availableMetricsWidgetsByName
    ),
    tableCellProps: {
      style: { width: '10%' }
    }
  },
  {
    dataPoint: TABLE_MODEL.COMMIT_COUNT,
    subscribeOnHover: true,
    name: getCellName(TABLE_MODEL.COMMIT_COUNT, availableMetricsWidgetsByName),
    tableCellProps: {
      style: { width: '10%' }
    }
  },
  {
    dataPoint: TABLE_MODEL.PR_NEW,
    subscribeOnHover: true,
    name: getCellName(TABLE_MODEL.PR_NEW, availableMetricsWidgetsByName),
    tableCellProps: {
      style: { width: '10%' }
    }
  },
  {
    dataPoint: TABLE_MODEL.REVIEWS,
    subscribeOnHover: true,
    name: getCellName(TABLE_MODEL.REVIEWS, availableMetricsWidgetsByName),
    tableCellProps: {
      style: { width: '10%' }
    }
  },
  {
    dataPoint: TABLE_MODEL.ACTIVE_DAYS,
    subscribeOnHover: true,
    name: getCellName(TABLE_MODEL.ACTIVE_DAYS, availableMetricsWidgetsByName),
    tableCellProps: {
      style: { width: '10%' }
    }
  },
  {
    dataPoint: TABLE_MODEL.DONE_BRANCHES,
    subscribeOnHover: true,
    name: getCellName(TABLE_MODEL.DONE_BRANCHES, availableMetricsWidgetsByName),
    tableCellProps: {
      style: { width: '10%' }
    }
  },
  {
    dataPoint: TABLE_MODEL.ACTIVE_BRANCHES,
    subscribeOnHover: true,
    name: getCellName(
      TABLE_MODEL.ACTIVE_BRANCHES,
      availableMetricsWidgetsByName
    ),
    tableCellProps: {
      style: { width: '10%' }
    }
  }
];

const useTableCols = ({
  selectedGroup,
  tableMetricsNames,
  availableMetricsWidgets
}) => {
  const availableMetricsWidgetsByName = _.keyBy(
    availableMetricsWidgets,
    'metrics[0].name'
  );

  const selectedGroupIsSynced = _.get(selectedGroup, '[0]isSynced');

  const cols = getCols({
    selectedGroupIsSynced,
    availableMetricsWidgetsByName
  }).filter(
    ({ dataPoint }) =>
      tableMetricsNames.includes(dataPoint) ||
      CONSTANT_CELLS.includes(dataPoint)
  );

  const colsAlignToRight = cols.map(item => {
    if (
      item.dataPoint === TABLE_MODEL.TEAM_NAME ||
      item.dataPoint === TABLE_MODEL.MEMBERS
    ) {
      return item;
    }

    return {
      ...item,
      align: 'right',
      rowAlign: 'right'
    };
  });

  const colsWithEmptyRightColumn = colsAlignToRight.concat({
    dataPoint: 'empty'
  });

  return colsWithEmptyRightColumn;
};

export default useTableCols;
